const SITE_URL = "https://abolfazlmohajeri.ir";
const OG_IMAGE = `${SITE_URL}/images/icons/web-app-manifest-512x512.png`;

const SEO = {
  en: {
    title: "Abolfazl Mohajeri",
    description:
      "I’ve been working in computer science field for several years and during my job experience, I acquired practical skills with interesting technologies.",
    ogLocale: "en_US",
    dir: "ltr"
  },
  fa: {
    title: "ابوالفضل مهاجری",
    description:
      "من چندین سال است که در زمینه مهندسی نرم‌افزار فعالیت می‌کنم و در طول حرفه‌ام، تجربیات عملی ارزشمندی در زمینه تکنولوژی‌های مختلف، وظایف چالش‌برانگیز و همکاری با افراد بااستعداد به دست آورده‌ام.",
    ogLocale: "fa_IR",
    dir: "rtl"
  }
};

function upsert(selector, tag, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    Object.keys(attrs).forEach((k) => el.setAttribute(k, attrs[k]));
    document.head.appendChild(el);
  }
  return el;
}

function setMetaName(name, content) {
  upsert(`meta[name="${name}"]`, "meta", { name }).setAttribute("content", content);
}

function setMetaProp(property, content) {
  upsert(`meta[property="${property}"]`, "meta", { property }).setAttribute("content", content);
}

export default function applySeo(locale) {
  const lang = SEO[locale] ? locale : "en";
  const seo = SEO[lang];
  const url = `${SITE_URL}/${lang}`;

  // Title + description
  document.title = seo.title;
  setMetaName("description", seo.description);

  // Open Graph
  setMetaProp("og:title", seo.title);
  setMetaProp("og:description", seo.description);
  setMetaProp("og:url", url);
  setMetaProp("og:locale", seo.ogLocale);
  setMetaProp("og:image", OG_IMAGE);

  // Twitter
  setMetaName("twitter:title", seo.title);
  setMetaName("twitter:description", seo.description);
  setMetaName("twitter:image", OG_IMAGE);

  // Canonical (self-referencing, per language)
  upsert('link[rel="canonical"]', "link", { rel: "canonical" }).setAttribute("href", url);

  // <html lang> + direction
  const html = document.documentElement;
  html.setAttribute("lang", lang);
  html.setAttribute("dir", seo.dir);
}
